export default __webpack_public_path__ + "static/media/Ntorq125Familia.81f0c068.webp";